import React from "react";
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { emphasize } from "@material-ui/core/styles/colorManipulator";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import AspectRatio from "./AspectRatio";

const useStyles = makeStyles((theme) => ({
  gridItem: {
    // Add border that contrasts lightly with background color.
    // We use boxShadow so that it's hidden around outer edge
    // due to container <Card> having overflow: hidden
    boxShadow: `1px 1px 0 0 ${emphasize(theme.palette.background.paper, 0.08)}`,
    textAlign: "center",
  },
  imageContainer: {
    position: "relative",          // establish a containing block
    margin: "0 auto 30px",
    width: "100%",
    minHeight: 260,                // give the section some height (adjust)
    overflow: "hidden",

    /* stretch the <img> so it *is* the background */
    "& img": {
      position: "absolute",
      inset: 0,                    // top:0 right:0 bottom:0 left:0
      width: "100%",
      height: "100%",
      objectFit: "cover",          // like background-size: cover
      zIndex: -1,                  // sit behind any overlay content
    },

    /* optional: subtle dark overlay for text legibility */
    "&::after": {
      content: '""',
      position: "absolute",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.35)", // tweak opacity as needed
      zIndex: -1,                          // keep it beneath text too
    },
  },
}));

function FeaturesSection(props) {
  const classes = useStyles();

  const items = [
    {
      title: "Business",
      body: "Branding, Marketing, Sales, Operations, Legal, Finance.",
      image: "",
    },
    {
      title: "Engineering",
      body: "Software Engineering, UX/UI, DevOps, Architecture, Infrastructure, Networking.",
      image: "",
    },
    {
      title: "Creative",
      body: "Content Generation, Design, Writing, Artistic Theory.",
      image: "",
    },
    {
      title: "Health & Wellness",
      body: "Diet, Exercise, Mental Health, Productivity.",
      image: "",
    },
    {
      title: "Education",
      body: "Math, Science, English, History, Science.",
      image: "",
    },
    {
      title: "Planning",
      body: "Strategy, Logistics, Schedule Management.",
      image: "",
    },
  ];

  return (
    <Section
      bgColor={props.bgColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container>
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={4}
          textAlign="center"
        />
        <Card raised={false}>
          <Grid container={true}>
            {items.map((item, index) => (
              <Grid
                item={true}
                xs={12}
                md={6}
                className={classes.gridItem}
                key={index}
              >
               <div className={classes.imageContainer}>
               <img src={item.image} alt={item.title} />

                <Box p={6}>
                    <AspectRatio ratio={4 / 3}>
                    </AspectRatio>
                  <Typography variant="h5" gutterBottom={true}>
                    {item.title}
                  </Typography>
                  <Typography variant="subtitle1">{item.body}</Typography>
                </Box>
                </div>
              </Grid>
            ))}
          </Grid>
        </Card>
      </Container>
    </Section>
  );
}

export default FeaturesSection;
